import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e935464a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "login-page"
};
import { XLFindPassword } from '@shining3d/xl-login';
import { useRouter, useRoute } from 'vue-router';
export default {
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var qwebChannelContext = null;
    var hideRetuenButton = ref(false);
    function submitAction(str) {
      if (qwebChannelContext) {
        qwebChannelContext.onMsg('resetButton', str);
      }
    }
    function receiveFial(param) {
      if (qwebChannelContext) {
        qwebChannelContext.onMsg('resetFail', "{\"username\":\"".concat(param.username || '', "\",\"password\":\"").concat(param.password || '', "\",\"phoneArea\":\"").concat(param.phoneArea || '', "\"}"));
      }
    }
    function receiveCallback(param) {
      // 重置成功，将账号和密码通过约定的方式发给qwebview
      if (qwebChannelContext) {
        qwebChannelContext.onMsg('loginInfo', "{\"username\":\"".concat(param.username || '', "\",\"password\":\"").concat(param.password || '', "\",\"phoneArea\":\"").concat(param.phoneArea || '', "\"}"));
      } else {
        setTimeout(function () {
          router.push({
            path: '/login'
          });
        }, 1500);
      }
    }
    function back() {
      router.back();
    }
    onMounted(function () {
      if (route.query.productLine) {
        var homel = document.getElementsByClassName('home-l')[0];
        var footer = document.getElementsByClassName('footer')[0];
        if (homel) {
          homel.style.display = 'none';
        }
        if (footer) {
          footer.style.display = 'none';
        }
        hideRetuenButton.value = true;
      }
    });

    // TODO: qwewebchannel 会触发两次
    // 加载软件端qwebchannel
    (function () {
      var qChannel = require('@/assets/js/qwebchannel.js');
      if (typeof qt !== 'undefined') {
        // eslint-disable-next-line
        qChannel.QWebChannel(qt.webChannelTransport, genQwebChannelInitFunc());
      }
    })();
    function genQwebChannelInitFunc() {
      return function (channel) {
        console.log('为软件端调用', channel);
        qwebChannelContext = channel.objects.context;
        if (qwebChannelContext) {
          var homel = document.getElementsByClassName('home-l')[0];
          var footer = document.getElementsByClassName('footer')[0];
          if (homel) {
            homel.style.display = 'none';
          }
          if (footer) {
            footer.style.display = 'none';
          }
          sessionStorage.setItem('ISQTSTYLE_TYPE', '1');
          hideRetuenButton.value = true;
          qwebChannelContext.onMsg('info', 'init success!');
        }
      };
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(XLFindPassword), {
        "product-key": "passport",
        onResetFeedback: receiveCallback,
        onResetFail: receiveFial,
        onSubmitAction: submitAction,
        onBackPrePage: back,
        "hide-retuen-button": hideRetuenButton.value
      }, null, 8, ["hide-retuen-button"])]);
    };
  }
};